import { createFileRoute } from '@tanstack/react-router';
import { FlagsPage } from '@/features/attendance/flags-page';
import { guardRoute } from '@/lib/route-guards';

/** `/hr/attendance/flags` (FR-ATT-10/11, attendance.manage): flagged punches and HR punches. */
export const Route = createFileRoute('/_app/hr/attendance_/flags')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/attendance/flags');
  },
  component: FlagsPage,
});
